<template>
  <header
    id="nav_container_168"
    class="fixed top-0 left-0 w-full z-50"
    :class="{ 'nav-overlay': useOverlay }"
  >
    <div class="nav-bar">
      <nav class="nav-row">
        <a @click="goPath('/')" class="nav-brand">
          <img class="nav-logo" src="@/assets/images/logo_info.webp" alt="河南一六八线缆" />
          <span class="nav-brand-name hidden-sm hidden-xs sm:inline-block">河南一六八线缆有限公司</span>
        </a>

        <!-- 桌面导航 -->
        <div class="hidden-sm hidden-xs md:flex items-center nav-links">
          <div class="relative group">
            <a
              @click="goPath('/')"
              class="nav-link"
              :class="{ 'is-active': isActive('/') }"
            >首页</a>
          </div>
          <div class="relative group">
            <a
              @click="goPath('/about')"
              class="nav-link"
              :class="{ 'is-active': isActive('/about') }"
            >关于我们</a>
          </div>
          <div class="relative group">
            <a
              @click="goPath('/productp')"
              class="nav-link"
              :class="{ 'is-active': isActive('/productp') }"
            >
              产品服务
              <i class="fa fa-chevron-down ml-1 text-xs transition-transform duration-300 group-hover:rotate-180"></i>
            </a>
            <div class="absolute left-0 top-full pt-1 w-56 z-20">
              <div
                class="nav-submenu py-1 rounded-md shadow-lg bg-white/95 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200"
              >
                <a href="/commonp?type=13" class="nav-sublink">布电线</a>
                <a href="/commonp?type=14" class="nav-sublink">电力电缆</a>
                <a href="/commonp?type=16" class="nav-sublink">控制电缆</a>
                <a href="/commonp?type=17" class="nav-sublink">低烟无卤电缆</a>
                <a href="/productp" class="nav-sublink">更多产品</a>
              </div>
            </div>
          </div>
          <div class="relative group">
            <a
              @click="goPath('/casep')"
              class="nav-link"
              :class="{ 'is-active': isActive('/casep') }"
            >工程案例</a>
          </div>
          <div class="relative group">
            <a
              @click="goPath('/honerp')"
              class="nav-link"
              :class="{ 'is-active': isActive('/honerp') }"
            >资质荣誉</a>
          </div>
          <div class="relative group">
            <a
              @click="goPath('/message')"
              class="nav-link"
              :class="{ 'is-active': isActive('/message') }"
            >联系我们</a>
          </div>
        </div>

        <div class="hidden-sm hidden-xs nav-phones md:flex items-center">
          <div class="telimg">
            <img src="@/assets/images/tel.webp" alt="服务热线" />
          </div>
          <div class="nav-phones-text">
            <span class="nav-phone-main">158-3716-1168</span>
            <span class="nav-phone-sub">199-3711-6888　0371-65555168</span>
          </div>
        </div>

         <!-- 移动端菜单按钮 -->
        <button 
          id="menu-toggle" 
          class="md:hidden p-2"
          @click="toggleMobileMenu"
          aria-label="切换菜单"
        >
          <i class="iconfont icon-gallery-view"></i>
        </button>
      </nav>
    </div>

     <div 
      class="md:hidden bg-white shadow-lg absolute w-full left-0 transition-all duration-300 ease-in-out"
      :class="{
        'max-h-0 opacity-0 overflow-hidden': !isMobileMenuOpen,
        'max-h-[500px] opacity-100': isMobileMenuOpen
      }"
    >
      <div class="px-4 py-3 space-y-1">
        <a 
          @click="handleMobileNavClick('/')" 
          class="block py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
        >
          首页
        </a>
        <a 
          @click="handleMobileNavClick('/about')" 
          class="block py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
        >
          关于我们
        </a>
        
        <!-- 移动端产品服务下拉菜单 -->
        <div>
          <button 
            class="flex items-center justify-between w-full py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
            @click="isProductSubmenuOpen = !isProductSubmenuOpen"
          >
            <span>产品服务</span>
            <i class="fa fa-chevron-down transition-transform duration-300" :class="{ 'rotate-180': isProductSubmenuOpen }"></i>
          </button>
          
          <div 
            class="pl-4 overflow-hidden transition-all duration-300"
            :style="{ maxHeight: isProductSubmenuOpen ? '300px' : '0' }"
          >
            <a 
              href="/commonp?type=13" 
              class="block py-2 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
              @click="closeMobileMenu"
            >
              布电线
            </a>
            <a 
              href="/commonp?type=14" 
              class="block py-2 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
              @click="closeMobileMenu"
            >
              电力电缆
            </a>
            <a 
              href="/commonp?type=16" 
              class="block py-2 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
              @click="closeMobileMenu"
            >
              控制电缆
            </a>
            <a 
              href="/commonp?type=17" 
              class="block py-2 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
              @click="closeMobileMenu"
            >
              低烟无卤电缆
            </a>
            <a 
              href="/productp" 
              class="block py-2 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
              @click="closeMobileMenu"
            >
              更多产品
            </a>
          </div>
        </div>
        
        <a 
          @click="handleMobileNavClick('/casep')" 
          class="block py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
        >
          工程案例
        </a>
        <a 
          @click="handleMobileNavClick('/honerp')" 
          class="block py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
        >
          资质荣誉
        </a>
        <a 
          @click="handleMobileNavClick('/message')" 
          class="block py-3 px-4 text-dark hover:bg-primary/10 hover:text-primary rounded-md transition-colors"
        >
          联系我们
        </a>
        
        <!-- 移动端联系电话 -->
        <div class="pt-2 pb-1 px-4">
          <div class="flex items-center space-x-3 py-2 border-t border-gray-100">
            <img src="@/assets/images/tel.webp" alt="联系电话图标" class="w-6 h-6" />
            <div class="text-dark font-bold text-sm leading-5">
              158-3716-1168<br />
              0371-65555168
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      isScrolled: false,
      overlayEnabled: false,
      overlayTimer: null,
      isMobileMenuOpen: false,
      isProductSubmenuOpen: false
    }
  },
  computed: {
    isHome() {
      return this.$route.path === '/'
    },
    useOverlay() {
      return this.isHome && this.overlayEnabled && !this.isScrolled
    }
  },
  watch: {
    $route(to) {
      this.closeMobileMenu()
      this.syncOverlay(to.path)
    }
  },
  mounted() {
    this.overlayEnabled = this.isHome && window.scrollY <= 50
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    clearTimeout(this.overlayTimer)
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 50
    },
    syncOverlay(path) {
      clearTimeout(this.overlayTimer)
      if (path === '/') {
        this.overlayTimer = setTimeout(() => {
          this.overlayEnabled = true
          this.onScroll()
        }, 120)
      } else {
        this.overlayEnabled = false
        this.$nextTick(() => this.onScroll())
      }
    },
    isActive(path) {
      const current = this.$route.path
      if (path === '/') return current === '/'
      if (path === '/productp') {
        return ['/productp', '/commonp', '/proinfo'].includes(current)
      }
      return current === path
    },
    goPath(path) {
      this.$router.push(path)
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      // 如果关闭主菜单，同时关闭子菜单
      if (!this.isMobileMenuOpen) {
        this.isProductSubmenuOpen = false
      }
      // 切换菜单时阻止页面滚动
      document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : ''
    },
    // 关闭移动端菜单
    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.isProductSubmenuOpen = false
      document.body.style.overflow = ''
    },
    // 移动端导航点击处理
    handleMobileNavClick(path) {
      this.goPath(path)
      this.closeMobileMenu()
    }
  }
}
</script>

<style lang="less" scoped>
#nav_container_168 {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(12px);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  transition: background-color 0.5s ease, border-color 0.5s ease,
    box-shadow 0.5s ease, backdrop-filter 0.5s ease;
  a {
    cursor: pointer;
  }
}

#nav_container_168.nav-overlay {
  background-color: rgba(255, 255, 255, 0);
  border-bottom-color: rgba(15, 23, 42, 0);
  backdrop-filter: blur(0);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
}

.nav-bar {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.nav-logo {
  height: 40px;
  width: auto;
  display: block;
}

.nav-brand-name {
  font-size: 18px;
  font-weight: 600;
  color: #ff8c00;
  letter-spacing: 0.04em;
  line-height: 1;
}

.nav-links {
  gap: 4px;
}

.nav-link,
.nav-phones-text,
#menu-toggle {
  color: #1d2129;
  transition: color 0.5s ease;
}

.nav-overlay .nav-link,
.nav-overlay .nav-phones-text,
.nav-overlay #menu-toggle {
  color: #fff;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 72px;
  padding: 0 14px;
  font-size: 17px;
  font-weight: 500;
  letter-spacing: 0.08em;
  line-height: 1;
  &:hover,
  &.is-active {
    color: #ff8c00;
  }
  &::after {
    content: "";
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: 18px;
    height: 2px;
    background: #ff8c00;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.5s ease;
  }
  &:hover::after,
  &.is-active::after {
    transform: scaleX(1);
  }
}

.nav-sublink {
  display: block;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.04em;
  line-height: 1.4;
  color: #334155;
  transition: color 0.2s ease, background-color 0.2s ease;
  &:hover {
    color: #fff;
    background-color: #ff8c00;
  }
}

.nav-phones {
  gap: 8px;
  flex-shrink: 0;
}

.telimg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.nav-phones-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.25;
  transition: color 0.5s ease;
}

.nav-phone-main {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.nav-phone-sub {
  font-size: 11px;
  opacity: 0.7;
  font-weight: 500;
  letter-spacing: 0;
}

@media (max-width: 767px) {
  .nav-bar {
    padding: 0 16px;
  }
  .nav-row {
    height: 60px;
  }
  .nav-logo {
    height: 36px;
  }
}
.nav-kb {
  .sublist-kb {
    background-color: rgba(255, 255, 255, 0.8);
  }
  .sublist-kb li a {
    display: block;
    // width: 142px;
    width: 100%;
    text-align: center;
    color: #555;
    text-indent: 0;
    height: 45px;
  }
  .sublist-kb li a:hover:after {
    height: 0px;
    width: 0px;
  }
  .sublist-kb li a:hover {
    color: @primaryColor;
    font-weight: 400;
  }
}

/* 移动端菜单动画 */
@keyframes slideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.md\:hidden > div > a {
  animation: slideDown 0.2s ease forwards;
  opacity: 0;
}

.md\:hidden > div > a:nth-child(1) { animation-delay: 0.05s; }
.md\:hidden > div > a:nth-child(2) { animation-delay: 0.1s; }
.md\:hidden > div > div:nth-child(3) { animation-delay: 0.15s; }
.md\:hidden > div > a:nth-child(4) { animation-delay: 0.2s; }
.md\:hidden > div > a:nth-child(5) { animation-delay: 0.25s; }
.md\:hidden > div > a:nth-child(6) { animation-delay: 0.3s; }
</style>
